export default Object.freeze({
  socialLink: `<li>
    <a class="ws-link">
        <ws-icon></ws-icon>
    </a>
  </li>`,
});
